import request from '../utils/request'

export const ranking = params => request({
  url: '/api/users/ranking',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
})